import * as React from 'react';
import { useAuth } from '../state/auth-state';
import { Navigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Alert, AlertDescription } from '../components/ui/alert';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../components/ui/card';

/**
 * Admin Console login page.
 * Redirects already-authenticated users to dashboard.
 * Shows EntraID OAuth2 login button and any error messages.
 */
export function LoginPage(): React.JSX.Element {
  const { state, login } = useAuth();

  // If already authenticated, redirect to dashboard
  if (state.isAuthenticated) {
    return <Navigate to="/admin-console" replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle>DelegatedDNS Admin</CardTitle>
          <CardDescription>
            Sign in with your organization account to access the administrator console.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {state.error && (
            <Alert variant="destructive">
              <AlertDescription>{state.error}</AlertDescription>
            </Alert>
          )}
          <Button
            onClick={login}
            className="w-full"
            size="lg"
            disabled={state.isLoading}
            loading={state.isLoading}
          >
            Sign in with Microsoft EntraID
          </Button>
          <p className="text-center text-xs text-muted-foreground">
            Only System Administrators and Domain Administrators can access this console.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
